// extracted by mini-css-extract-plugin
export default {"box":"addtype_box__6nthm","buttonChOpt":"addtype_buttonChOpt__a7b+g"};